let el
let target
let targetTop
let isHidden = false
let offsetViewHeight = 0.25

export function LetsTalk() {
    el = document.querySelector('.js-lets-talk')
    if (!el) {
        return
    }

    let url = new URL(el.href)

    target = document.querySelector(url.hash)
    if (!target) {
        return
    }

    const cbr = target.getBoundingClientRect()
    targetTop = cbr.top + currentScroll() - offsetViewHeight * window.innerHeight

    window.addEventListener('scroll', onScroll)
    window.addEventListener('resize', onResize)
}

function onResize() {
    const cbr = target.getBoundingClientRect()
    targetTop = cbr.top + currentScroll() - offsetViewHeight * window.innerHeight
}

function onScroll() {
    if (currentScroll() > targetTop && !isHidden) {
        hide()
    } else if (currentScroll() < targetTop && isHidden) {
        show()
    }
}

function hide() {
    el.classList.add('is-hidden')
    isHidden = true
}

function show() {
    el.classList.remove('is-hidden')
    isHidden = false
}

function currentScroll() {
    return window.scrollY || window.pageYOffset
}
